<template>
  <span class="icon-share" @click="showShare()" />
</template>

<script>
import Vue from 'vue'
import qs from 'qs'
import i18n from '@/utils/i18n'
import native, { isMC } from '@/utils'
import { compareVersion } from '@duoke/tools'
import registerConfirm from '../Confirm'
import { getUserAgent } from '../../utils/nativeInfo'

const { NativeFuncs, callNativeAsyncFunc, appInfo } = native

if (!Vue.prototype.$confirm) {
  Vue.use(registerConfirm)
}

const base = {
  21: '2.4.19', // IOS Air-黑端企业版
  31: '2.4.19', // IOS Air-黑端标准版
  22: '2.7.6', // IOS Air-红端企业版
  32: '2.7.6', // IOS Air-红端标准版
  41: '2.2.3', // Android Air-黑端
  42: '2.3.3', // Android Air-红端
}

const getShareUrl = () => {
  const { search, hash, href } = window.location
  const key =
    qs.parse(search.slice(1)).key || qs.parse(hash.split('?')[1] || '').key
  const keyword = qs.parse(search.slice(1)).keyword
  let share
  if ((hash && hash.indexOf('?') > -1) || (search && !hash)) {
    share = '&dkshare=1'
  } else {
    share = '?dkshare=1'
  }
  // 默认分享链接不带key
  return encodeURI(
    `${href
      .replace(`key=${key}`, '')
      .replace(`keyword=${encodeURI(keyword)}`, '')}${share}`
  )
  // 默认分享链接带key
  // return encodeURI(`${href}${share}`)
}
const thumbImg = {
  admin: 'http://duoke-image.oss-cn-hangzhou.aliyuncs.com/logo/64_admin.png',
  sale: 'http://duoke-image.oss-cn-hangzhou.aliyuncs.com/logo/64_sale.png',
  // adminMC: 'https://mc2-image.oss-eu-central-1.aliyuncs.com/logo/admin_64.png',
  // saleMC: 'https://mc2-image.oss-eu-central-1.aliyuncs.com/logo/sale_64.png',

  adminMC: 'https://mc2-image.oss-eu-central-1.aliyuncs.com/logo/mc_64.png',
  saleMC: 'https://mc2-image.oss-eu-central-1.aliyuncs.com/logo/mc_64.png',
}
const thumbUrl =
  thumbImg[`${getUserAgent().portType || 'admin'}${isMC() ? 'MC' : ''}`]
const moduleName = window.location.pathname.slice(1).replace('.html', '')
const pathConfig = {
  'help-center': i18n.t('help_center'),
  cms: i18n.t('cms'),
}
const shareConfig = {
  'help-center': i18n.t('help_document'),
  cms: i18n.t('soft_spread'),
}
const module = pathConfig[moduleName]

export default {
  props: {
    message: {
      // 分享内容
      type: Object,
    },
  },
  methods: {
    // 控制分享面板
    showShare() {
      if (isMC() || compareVersion(appInfo.appVersion, base[appInfo.projId])) {
        // 达成目标, 调用接口
        this.share()
      } else {
        this.$confirm({
          haveCancel: false,
          title: '版本过低，暂不能使用此功能，请尽快更新',
          okText: '知道了',
        })
      }
    },
    // 分享
    share() {
      const titleDom = document.querySelector('.title')
      const descDom = document.querySelector('[name="description"]')
      const imgDom = document.querySelectorAll('img')[0]
      const pDom = document.querySelectorAll('p')[1]

      const platform = isMC() ? ['origin'] : ['qq', 'wechat', 'timeline']

      const query = {
        type: 'ShareContentUrl',
        webUrl: getShareUrl(), // 地址链接
        platform, // 新版本协议
        plateform: platform, // 老版本兼容，不可删
        title: titleDom ? titleDom.innerText : document.title, // 标题
        description: descDom ? descDom.content : pDom ? pDom.innerText : '', // 描述
        thumbUrl: !!imgDom && imgDom.naturalWidth < 300 ? imgDom.src : thumbUrl, // 图片链接
        module,
        moduleName,
        contentCategory: shareConfig[moduleName],
        ...(this.message || {}),
      }
      callNativeAsyncFunc(NativeFuncs.ALERT.SHARE, query).then(() => {
        // this.$toast({ text: '分享成功' })
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Share/Share.vue